import ApiCompanyBenefit from 'types/api/CompanyBenefit';

import Company from 'models/Company';
import JobBenefit from 'models/JobBenefit';
import Model from 'models/Model';

export default class CompanyBenefit implements Model {
    id: string;
    company: Company;
    jobBenefit: JobBenefit;
    name: string;

    constructor(data: ApiCompanyBenefit) {
        this.id = data.id;
        this.company = data.company && new Company(data.company);
        this.jobBenefit = data.jobBenefit && new JobBenefit(data.jobBenefit);
        this.name = data.name && data.name;
    }
}